// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"0ea8edf8","829":"8fc9af4b","878":"a85cca66","921":"473e226e"}[chunkId] + ".chunk.js";
};